import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect, useDispatch, useSelector } from 'react-redux';
import { hideModal } from '../../store/actions/index';
import * as actions from '../../store/actions/index';
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../routes';
import { useForm, Controller } from "react-hook-form";

import Select from 'react-select'

const SaveProductSystemItemsModal = (props) => {

  const dispatch = useDispatch();
  let history = useHistory();
  const { t } = useTranslation();

  const [selectVirgin, setSelectVirgin] = useState(true);
  const [initialSelection, setInitialSelection] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [optionsProjectUnits, setOptionsProjectUnits] = useState(null);
  const [selectedProjectUnit, setSelectedProjectUnit] = useState(null);

  const allProjects = useSelector(state => actions.getAllProjects(state));
  const loadingProjects = useSelector(state => state.inventory.loading_project );
  const wizardValues = useSelector(state => state.wizard.selectedSteps);

  const { handleSubmit, errors, register, setValue, control } = useForm();

  let projectOptions = [];

  console.log(errors);

  const onSubmit = data => {
    dispatch( actions.createProductSolution(data['projectunits'],
                                            wizardValues,
                                            props.formObject.selectedSystemItems,
                                            data,
                                            props.formObject.calcData,
                                            props.formObject.calcResult) ).then(
      () => dispatch( hideModal() )).then(
        history.push(ROUTES.TO_PROJECT(selectedProject.value)) ).then(
          () =>  dispatch( actions.initProject(selectedProject.value)) ).then(
            () => dispatch( actions.wizardReset() ));
  } ;

  useEffect(() => {
    dispatch( actions.initProjects() )
    setInitialSelection(wizardScope());
  }, []);

  const wizardScope = useSelector(state => {
    return () => actions.getWizardScope(state);
  });

  useEffect(() => {
    if (initialSelection !== null && selectVirgin === true) {
      const selectedObject = projectOptions.filter(function(element, index, arr){ return element.value === initialSelection.projectscope});
      setSelectedProject(selectedObject[0]);
      setValue("project", selectedObject[0]);
    }
  }, [initialSelection]);

  useEffect(() => {
    if (optionsProjectUnits !== null && initialSelection !== null && selectVirgin === true) {
      const selectedObject = optionsProjectUnits.filter(function(element, index, arr){ return element.value === initialSelection.projectunitscope});
      if (selectedObject[0] !== null && selectedObject[0] !== undefined) {
        setValue("projectunits", selectedObject[0].value)
      }

      setSelectedProjectUnit(selectedObject[0]);
    }
  }, [optionsProjectUnits]);

  useEffect(() => {
    if (optionsProjectUnits !== null && optionsProjectUnits.length > 0 && initialSelection !== null && selectVirgin === true) {
      setSelectVirgin(false);
    }
  }, [selectedProjectUnit]);


  if ( !loadingProjects ) {
    projectOptions = allProjects.map( project => {
      return {
        value: project.id,
        label: project.title
      }
    })
  }

  const thisProject = useSelector(state => {
    return (projectId) => actions.getProject(state, projectId)
  });

  const projectunits = useSelector(state => {
    return (projectunitIds) => actions.getInventoryObjects(state, 'projectunits', projectunitIds)
  });

  useEffect(() => {
    if (selectedProject !== null && selectedProject !== undefined && thisProject(selectedProject.value) !== undefined && thisProject(selectedProject.value).projectunits !== undefined) {
    setOptionsProjectUnits(projectunits(thisProject(selectedProject.value).projectunits).map( unit => {
      return {
        value: unit.id,
        label: unit.title
      }
    }))} else {
      setOptionsProjectUnits([])
    }
  }, [selectedProject]);

  const onChangeProject = (e) => {
    setSelectedProject(e);
    setValue("project", e);
    setSelectedProjectUnit(null);
    setValue("projectunits", null);
  }

  const onChangeProjectUnit = e => {
    setValue("projectunits", e.value);
    setSelectedProjectUnit( (optionsProjectUnits && optionsProjectUnits.filter(function(element, index, arr){ return element.value === e.value})[0]) || null )
  }


  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName] !== undefined)?
       <div className="invalid-feedback">
          { t('modal.solution_metadata.form.' + fieldName + '.' + errors[fieldName]['type']) }
        </div> : null
  }

  const isItValid = (errors, fieldName) => {
    return (errors[fieldName] !== undefined)? "is-invalid" : ""
  }

  return (
  	<Modal show={true} onHide={props.hideModal} animation={true}>
  		<div className="modal-header">
  			<h5 className="modal-title">{ t( 'modal.save_productsolution.title' ) }</h5>
  			<button type="button" onClick={props.hideModal} className="close btn btn-round" data-dismiss="modal"> <i className="material-icons">close</i>
  			</button>
  		</div>
  		<Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="form">


          <div className="form-group">
            <label>{ t( 'modal.save_productsolution.form.project.label' ) }</label>
             <Controller
                control={control}
                name="project"
                defaultValue={selectedProject}
                render= {({value, ref}) => (
                <Select
                  {...register("project", { required: true })}
                  placeholder={ t( 'modal.save_productsolution.form.select_project.placeholder' ) }
                  options={projectOptions}
                  value={selectedProject}
                  onChange={ (e) => onChangeProject(e) }
                  inputRef={ref}
                  styles={
                    (errors.project)?
                    { control: (provided, { isFocused }) => ({
                        ...provided,
                        border: "1px solid red",
                        boxShadow: "0",
                        fontSize: ".875rem",
                        ':hover': { border: "1px solid red" }})
                    } : { control: (provided, { isFocused }) => ({
                        ...provided,
                        boxShadow: "0",
                        fontSize: ".875rem",
                        border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                        ':hover': { border: "1px solid #dee2e6" }})
                    }}
                />
              )}
              />
              { errors.project && (
                 <div className="invalid-feedback" style={{display: "block"}}>
                   { t('form.save_product_system.project.required') }
                 </div>
              )}
          </div>
          <div className="form-group">
            <label>{ t( 'modal.save_productsolution.form.projectunit.label' ) }</label>
            <Controller
               control={control}
               name="projectunits"
               defaultValue={selectedProjectUnit}
               render= {({value, ref}) => (
               <Select
                 {...register("projectunits", { required: true })}
                 options={optionsProjectUnits}
                 value={ selectedProjectUnit }
                 onChange={ onChangeProjectUnit }
                 placeholder={ t( 'modal.save_productsolution.form.select_projectunit.placeholder' ) }
                 inputRef={ref}
                 styles={
                   (errors.projectunits)?
                   { control: (provided, { isFocused }) => ({
                       ...provided,
                       border: "1px solid red",
                       boxShadow: "0",
                       fontSize: ".875rem",
                       ':hover': { border: "1px solid red" }})
                   } : { control: (provided, { isFocused }) => ({
                       ...provided,
                       boxShadow: "0",
                       fontSize: ".875rem",
                       border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                       ':hover': { border: "1px solid #dee2e6" }})
                   }}

               />
             )}
             />
             { errors.projectunits && errors.projectunits.type === "required" && (
                <div className="invalid-feedback" style={{display: "block"}}>
                  { t('form.save_product_system.projectunit.required') }
                </div>
             )}
          </div>

          <div className="form-group">
              <label htmlFor="description" className="col-form-label">{ t( 'modal.product_solution_meta_data.form.description.label' ) }</label>
            <textarea
              name="description"
              className={"form-control " + isItValid(errors, 'description') }
              rows="1"
              ref={register({maxLength: 60})} />
              { errors.description && errors.description.type === "maxLength" &&
               (errorMessage(errors, 'description'))
              }
          </div>

        </form>
  		</Modal.Body>
  		<Modal.Footer>
  			<Button variant="secondary" onClick={props.hideModal}>{t( 'modals.common.button.close' )}</Button>
  			<button type="submit" onClick={handleSubmit(onSubmit)} className="btn btn-primary">{t( 'modals.common.button.save' )}</button>
  		</Modal.Footer>
  	</Modal>
  )
}


const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal())
})

export default connect(null, mapDispatchToProps)(SaveProductSystemItemsModal)



// WEBPACK FOOTER //
// ./src/components/Modals/SaveProductSystemItemsModal.js